import { render } from "./excelFileDownloadComponent.vue?vue&type=template&id=20bdfa27"
import script from "./excelFileDownloadComponent.vue?vue&type=script&lang=js"
export * from "./excelFileDownloadComponent.vue?vue&type=script&lang=js"

import "./excelFileDownloadComponent.vue?vue&type=style&index=0&id=20bdfa27&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__